import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calculator, TrendingUp, Handshake, Briefcase } from 'lucide-react';
import { services } from '../../data/mock';

const iconMap = {
  Calculator: Calculator,
  TrendingUp: TrendingUp,
  HandshakeIcon: Handshake,
  Briefcase: Briefcase
};

const ServicesSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="caption mb-4 block">Unsere Leistungen</span>
          <h2 className="heading-2 mb-6">
            Leistungen rund um <span className="text-[#FF0000]">Unternehmensbewertungen & M&A</span>
          </h2>
          <p className="body-medium max-w-2xl mx-auto">
            Von der ersten Wertermittlung bis zum erfolgreichen Abschluss – wir begleiten Sie.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Link
                key={service.href}
                to={service.href}
                className="group relative overflow-hidden rounded-2xl bg-[#f8f9fa] border border-gray-100 hover:border-[#FF0000]/30 hover:shadow-lg transition-all duration-300"
              >
                <div className="p-8 lg:p-10">
                  {/* Icon */}
                  <div className="w-16 h-16 rounded-xl bg-[#FFE5E5] flex items-center justify-center mb-6 group-hover:bg-[#FF0000]/20 transition-colors">
                    {IconComponent && <IconComponent className="w-8 h-8 text-[#FF0000]" />}
                  </div>

                  {/* Content */}
                  <h3 className="heading-3 mb-4 group-hover:text-[#FF0000] transition-colors">
                    {service.title}
                  </h3>
                  <p className="body-medium mb-6">
                    {service.description}
                  </p>

                  {/* Keywords */}
                  <div className="flex flex-wrap gap-2 mb-6">
                    {service.keywords.map((keyword, kIndex) => (
                      <span
                        key={kIndex}
                        className="px-3 py-1 rounded-full bg-white text-[#5a5d5b] text-xs font-medium border border-gray-200"
                      >
                        {keyword}
                      </span>
                    ))}
                  </div>

                  {/* Link */}
                  <div className="flex items-center gap-2 text-[#FF0000] font-medium">
                    <span>Mehr erfahren</span>
                    <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>

                {/* Hover gradient */}
                <div className="absolute inset-0 bg-gradient-to-br from-[#FF0000]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
